// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__82qAT","pageItem":"Pagination_pageItem__Tvk6x","active":"Pagination_active__THnKb","ellipsis":"Pagination_ellipsis__cGxse"};